import React, { FunctionComponent, useCallback, useRef } from 'react'
import { FormattedMessage } from 'react-intl'

import BottomSheetGorhom from '@gorhom/bottom-sheet'
import styled, { useTheme } from 'styled-components/native'

import { BodyText } from '../../atoms/bodyText/BodyText'
import { LoadingIndicator } from '../../atoms/icons/LoadingIndicator'
import { Title } from '../../atoms/title/Title'
import { Modal } from '../../organisms/modal/Modal'
import { TitleSize } from '../../styles/typeStyles'
import { ThemeType } from '../../utils/themes/ThemeProvider'
import { tID } from '../../utils/utils'

export type ProviderCalendarLoadingModalProps = {
  isVisible?: boolean
  isCalendarSelection?: boolean
}

const Container = styled.View(({ theme }) => ({
  flexDirection: 'column',
  gap: theme.spacing['16px'],
  alignItems: 'center',
}))

const HeaderText = styled(Title)(({ theme }) => ({
  marginTop: theme.spacing['8px'],
}))

const LoadingContainer = styled.View({
  width: '140px',
  height: '140px',
  alignItems: 'center',
  justifyContent: 'center',
})

export const ProviderCalendarLoadingModal: FunctionComponent<ProviderCalendarLoadingModalProps> = ({
  isVisible = false,
  isCalendarSelection = false,
}) => {
  const theme = useTheme() as ThemeType
  const ref = useRef<BottomSheetGorhom>(null)
  const openBottomSheet = useCallback(() => {
    ref.current?.expand()
  }, [])
  return (
    <Modal
      visible={isVisible}
      bottomSheetRef={ref}
      snapPoints={[550]}
      width='600px'
      onLayout={openBottomSheet}
      modalContents={
        <Container testID={tID('ProviderCalendarLoadingModal')}>
          <LoadingContainer>
            <LoadingIndicator topPadding={0} size={64} />
          </LoadingContainer>
          <HeaderText
            textAlign='center'
            size={TitleSize.MEDIUM}
            text={
              isCalendarSelection ? (
                <FormattedMessage
                  defaultMessage='Saving your selections'
                  description='Title for modal where calendar selection is saving'
                />
              ) : (
                <FormattedMessage
                  defaultMessage='Setting up your calendar'
                  description='Title for modal where calendar template is saving'
                />
              )
            }
          />
          <BodyText
            textAlign='center'
            color={theme.colors.textSecondary}
            text={
              isCalendarSelection ? (
                <FormattedMessage
                  defaultMessage='Do not refresh or close this screen'
                  description='Body text for modal where calendar selection is saving'
                />
              ) : (
                <FormattedMessage
                  defaultMessage="Don't refresh. We're syncing your template with Google Calendar. This may take a couple of minutes. Your screen will refresh automatically once done."
                  description='Body text for modal where calendar template is saving'
                />
              )
            }
          />
        </Container>
      }
      onRequestClose={() => {}}
      onCloseEnd={() => {}}
    />
  )
}
